module.exports = __webpack_public_path__ + "static/media/tour-pattern.d7e0b762.png";